/*
 * @Descripttion: 系统中全局变量
 * @Author: pangting
 * @Date: 2020-04-20 15:21:30
 */

/**
 * 登录用户信息
 */
 export interface UserInfor {
[x: string]: any
passwordAuthentication?: any
lastLoginTime?: any
// passwordAuthentication: any
    /**
     * 用户Id
     */
    id: number,
    /**
     * 用户当前机构
     */
    biid: number,
    /**
     * 用户当前角色
     */
    roleId: number,
    /**
     * 账户
     */
    userName: string,
    /**
     * 姓名
     */
    userTrueName: string,
    /**
     * 性别
     */
    userGender: number,
    /**
     * 电话号码
     */
    userPhone: string,
    /**
    * 密码过期时间
    */
    expiredDate: string,
    /**
     * 角色code
     */
    roleCode: string,

    userIcon: string,
    userImage: string,
    SKey:string,
    enterpriseinfoId: number,
    enterpriseinfoName:string
    isLow: number,
}
export interface RoleInfo {
    id: number,
    roleName: string,
    welcomeRoute: string,
    roleCode: string,
    description: string
    SubSystemId?:number,
    welcomeUrl?:string
}

export interface ItemInfo {
    id: number,
    itemName: string,
    subProjectName: string,
    projectId: number,
    skey?:string
    enterpriseinfoName?:string
}
export interface RoadInfo {
    id: number,
    roadName: string,
    roadBimconfig: string
    roadProjectConfig: string
    roadConstructConfig: string
}
export interface Institutioninfor {
    id: number,
    institutionName: string,
    institutionNameNature: string,
    institutionNature: number
    RootId:number
    PId:number
    pId:number
    contractFees:string
}
export interface SubSysteminfor {
    id: number,
    subSystemName: string,
    moduleinforList?:any
}

/**
 * 菜单项
 */
export interface MenuItem {
    name: string,
    icon: string,
    link: string,
    operates: string,
    userData: string,
    children: MenuItem[]
}
export interface RoadList {
    id: number,
    roadName: string,
}


export interface GlobalType {
    /**
     * 当前用户信息
     */
    localUser: UserInfor,
    roleInfo: RoleInfo,
    projectInfo?:any,
    businessInfo?:any,
    /**
     * 当前菜单信息
     */
    menuItems?: MenuItem[],
    itemInfo: ItemInfo,
    institutioninfor: Institutioninfor
    subSysteminfor: SubSysteminfor
    roadInfo: RoadInfo,
    roadList?:RoadList[]
    
    
}

const global: GlobalType = {
    localUser: {
        "id": 0,
        biid: 0,
        "userName": "",
        "userTrueName": "",
        "roleId": 0,
        userGender: 1,
        userPhone: "string",
        expiredDate: "",
        roleCode: "",
        userIcon: '',
        userImage: '',
        SKey:"",
        enterpriseinfoId:0,
        enterpriseinfoName:"",
        isLow: 2
    },
    roleInfo: {
        id: 0,
        roleName: "",
        welcomeRoute: "",
        roleCode: "",
        description: ""
    },
    itemInfo: {
        id: 0,
        itemName: "",
        subProjectName: '',
        projectId: 0,
        enterpriseinfoName:""
    },
    institutioninfor: {
        id: 0,
        institutionName: "",
        institutionNameNature:'',
        institutionNature: 0,
        RootId:0,
        PId:0,
        pId:0,
        contractFees:""
    },
    subSysteminfor: {
        id: 0,
        subSystemName: ""
    },
    roadInfo: {
        id: 0,
        roadName: "",
        roadBimconfig:"",
        roadProjectConfig:'',
        roadConstructConfig:''
    },
};

export default global;

declare module "vue/types/vue" {
    interface Vue {
        $globalData_Plms: GlobalType;
        $bus: Vue;
    }
}
